import U from "../../felles/Utils";
import { TableHeaders } from "../../models/TableHeaders";
import NV05Employee from "../../models/NV05";
import pageImpl from "../../models/PageImpl";
import ApiResponse from "../../models/payload/APIResponse";
import * as actionTypesNV05 from "../actions/actionTypesNV05";
import * as fromApp from "../rootReducer";

export interface FeatureState extends fromApp.AppState {
  state: NV05;
}

export interface NV05 {
  page: pageImpl<NV05Employee>;
  redirectPath: string;
  error: any;
  tableHeaders: TableHeaders[];
  isFetchingNV05ListEmployee: boolean;
  order?: string;
  orderBy?: string;
  isReset: boolean;
  isResetFormEnabled: boolean;
  keyValuePairs4NV05: { key: string; value: any }[];
  currentRowFocused: number;
  scrollTopPosition: number;
  transStateInsertEmployee: number;
  transStateUpdateEmployee: number;
  transStateDeleteEmployee: number;
  transStateDialogEmployee: number;
  transDialogEmployeeFeedback: ApiResponse;
  selectedEmployee: NV05Employee; // Optional, used for selected employee in the list
  listFormData?: any;
  subFormData?: any;
  rowData?: any;
  employeeId: string;
  doesEmployeeIdExist: string;
  locationByPostalCode: string;
  stateKeypressed: number;
}

const initialState = {
  page: new pageImpl(),
  redirectPath: "/",
  error: undefined,
  tableHeaders: [],
  isFetchingNV05ListEmployee: false,
  order: '',
  orderBy: '',
  isReset: false,
  isResetFormEnabled: false,
  keyValuePairs4NV05: [],
  currentRowFocused: -1,
  scrollTopPosition: 0,
  transStateInsertEmployee: 0,
  transStateUpdateEmployee: 0,
  transStateDeleteEmployee: 0,
  transStateDialogEmployee: 0,
  transDialogEmployeeFeedback: {} as ApiResponse, // Initialize as empty object
  selectedEmployee: {} as NV05Employee, // Initialize as empty object},
  listFormData: {} as any, // Initialize as empty object},
  subFormData: {} as any, // Initialize as empty object},
  rowData: {} as any, // Initialize as empty object},
  employeeId: '',
  doesEmployeeIdExist: '',
  locationByPostalCode: '',
  stateKeypressed: -1,
} as NV05;


export const setLockKeypressed = (state: NV05, action: any) => {
  return U.updateStore(state, { stateKeypressed: action.payload });
};

export const setTransDialogEmployeeFeedback = (state: NV05, action: any) => {
  return U.updateStore(state, { transDialogEmployeeFeedback: action.payload });
};

export const setTransStateInsertEmployee = (state: NV05, action: any) => {
  return U.updateStore(state, { transStateInsertEmployee: action.payload });
};

export const setTransStateUpdateEmployee = (state: NV05, action: any) => {
  return U.updateStore(state, { transStateUpdateEmployee: action.payload });
};

export const setTransStateDeleteEmployee = (state: NV05, action: any) => {
  return U.updateStore(state, { transStateDeleteEmployee: action.payload });
};

export const setTransStateDialogEmployee = (state: NV05, action: any) => {
  return U.updateStore(state, { transStateDialogEmployee: action.payload });
};

export const setSelectedEmployee = (state: NV05, action: any) => {
  return U.updateStore(state, { selectedEmployee: action.payload });
};

const setScrollTopPosition = (state: NV05, action: any) => {
  return U.updateStore(state, { scrollTopPosition: action.payload });
}

const setKeyValuePairs4NV05 = (state: NV05, action: any) => {
  return U.updateStore(state, { keyValuePairs4NV05: action.payload });
};

const setCurrentRowFocused = (state: NV05, action: any) => {
  return U.updateStore(state, { currentRowFocused: action.payload });
};
//
const NV05ListeGetStart = (state: NV05) => {
  return U.updateStore(state, { isFetchingNV05Liste: true });
};
//
const NV05ListeGetSuccess = (state: NV05, action: any) => {
  return U.updateStore(state, {
    page: action.payload,
    isFetchingNV05Liste: false,
  });
};
//
const NV05ListeGetFailed = (state: NV05, action: any) => {
  return U.updateStore(state, { isFetchingNV05Liste: false, error: action });
};
//  Reset form
const NV05ResetForm = (state: NV05, action: any) => {
  if (action.payload) {
    return U.updateStore(state, { isReset: true, page: new pageImpl(), tableHeaders: [] });
  } else {
    return U.updateStore(state, { isReset: false });
  }
};
//  Set Reset state enabled
const NV05SetResetFormEnabled = (state: NV05, action: any) => {
  return U.updateStore(state, { isResetFormEnabled: action.payload });
};
//
const NV05ClearComponentStore = (state: NV05) => {
  return U.updateStore(state, { ...initialState });
};
//  Update column header list
//  This is used to update the column headers in the NV05 component
const NV05UpdateColumnHeaderList = (state: NV05, list: TableHeaders[]) => {
  return U.updateStore(state, { tableHeaders: list });
};

const getEmployeeIdSuccess = (state: NV05, action: any) => {
  return U.updateStore(state, { employeeId: action.payload });
};
//
const getEmployeeIdFailed = (state: NV05, action: any) => {
  return U.updateStore(state, { employeeId: action.payload });
};

const getEmployeeIdValidateSuccess = (state: NV05, action: any) => {
  return U.updateStore(state, { employeeId: action.payload.employeeId, doesEmployeeIdExist: action.payload.message });
};

const getEmployeeIdValidateFailed = (state: NV05, action: any) => {
  return U.updateStore(state, { employeeId: action.payload.employeeId, doesEmployeeIdExist: action.payload.message });
};

const getLocationByPostalCodeSuccess = (state: NV05, action: any) => {
  return U.updateStore(state, { locationByPostalCode: action.payload.postalLocation });
}

const getLocationByPostalCodeFailed = (state: NV05, action: any) => {
  return U.updateStore(state, { locationByPostalCode: action.payload });
};

const setListFormData = (state: NV05, action: any) => {
  return U.updateStore(state, { listFormData: action.payload });
};

const setSubFormData = (state: NV05, action: any) => {
  return U.updateStore(state, { subFormData: action.payload });
};

const setRowData = (state: NV05, action: any) => {
  return U.updateStore(state, { rowData: action.payload });
};

//  Reducer for NV05
const NV05 = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypesNV05.NV05_LIST_GET_INIT:
      return NV05ListeGetStart(state);
    case actionTypesNV05.NV05_LIST_GET_SUCCESS:
      return NV05ListeGetSuccess(state, action);
    case actionTypesNV05.NV05_LIST_GET_FAILED:
      return NV05ListeGetFailed(state, action);
    case actionTypesNV05.NV05_RESET_FORM:
      return NV05ResetForm(state, action);
    case actionTypesNV05.NV05_SET_COLUMN_HEADER_LIST:
      return NV05UpdateColumnHeaderList(state, action.list);
    case actionTypesNV05.NV05_RESET_COMPONENT_STORE:
      return NV05ClearComponentStore(state);
    case actionTypesNV05.NV05_SET_RESET_FORM_ENABLED:
      return NV05SetResetFormEnabled(state, action);
    case actionTypesNV05.SET_KEY_VALUE_PAIRS_4_NV05:
      return setKeyValuePairs4NV05(state, action);
    case actionTypesNV05.SET_CURRENT_ROW_FOCUSED:
      return setCurrentRowFocused(state, action);
    case actionTypesNV05.SET_SCROLL_TOP_POSITION:
      return setScrollTopPosition(state, action);
    case actionTypesNV05.SET_SELECTED_PERSON:
      return setSelectedEmployee(state, action);
    case actionTypesNV05.SET_LIST_FORMDATA:
      return setListFormData(state, action);
    case actionTypesNV05.SET_SUB_FORMDATA:
      return setSubFormData(state, action)
    default:
      return state;
  }
};

export default NV05;









